import React from 'react';

const Turn = (props) =>{
    return(
        <div className="turn">
            {props.turn}
        </div>
    );
}

export default Turn;